import React from 'react';
import { Box, Typography } from '@mui/material';

// Grid positions (col,row) approximating each province's location. 5 cols x 4 rows.
const TILE_LAYOUT = {
  'Mashonaland West': { col: 1, row: 0 },
  'Mashonaland Central': { col: 2, row: 0 },
  'Mashonaland East': { col: 3, row: 0 },
  'Matabeleland North': { col: 0, row: 1 },
  Harare: { col: 2, row: 1 },
  Manicaland: { col: 4, row: 1 },
  Bulawayo: { col: 0, row: 2 },
  Midlands: { col: 1, row: 2 },
  Masvingo: { col: 3, row: 2 },
  'Matabeleland South': { col: 1, row: 3 },
};

const TILE_W = 150;
const TILE_H = 104;
const GAP = 10;
const VIEW_W = 5 * (TILE_W + GAP) + GAP;
const VIEW_H = 4 * (TILE_H + GAP) + GAP;

function fillFor(total, max) {
  if (!total) return '#fbeaea';
  const ratio = max > 0 ? total / max : 0;
  if (ratio > 0.75) return '#1b5e20';
  if (ratio > 0.5) return '#2e7d32';
  if (ratio > 0.25) return '#4caf50';
  return '#a5d6a7';
}
function textColorFor(total, max) {
  const ratio = max > 0 ? total / max : 0;
  return total && ratio > 0.5 ? '#ffffff' : '#1b3a26';
}
const SHORT = {
  'Mashonaland West': 'Mash. West', 'Mashonaland Central': 'Mash. Central', 'Mashonaland East': 'Mash. East',
  'Matabeleland North': 'Mat. North', 'Matabeleland South': 'Mat. South',
};

export default function ZimbabweProvinceMap({ data = [] }) {
  const byProvince = data.reduce((acc, p) => { acc[p.province] = p; return acc; }, {});
  const max = data.reduce((m, p) => Math.max(m, p.total || 0), 0);

  return (
    <Box>
      <svg viewBox={`0 0 ${VIEW_W} ${VIEW_H}`} width="100%" role="img" aria-label="Zimbabwe coverage by province">
        {Object.entries(TILE_LAYOUT).map(([province, pos]) => {
          const stats = byProvince[province] || { contractors: 0, verifiers: 0, total: 0 };
          const x = GAP + pos.col * (TILE_W + GAP);
          const y = GAP + pos.row * (TILE_H + GAP);
          const fill = fillFor(stats.total, max);
          const tColor = textColorFor(stats.total, max);
          const isGap = !stats.total;
          return (
            <g key={province}>
              <rect x={x} y={y} width={TILE_W} height={TILE_H} rx={10} fill={fill}
                stroke={isGap ? '#d32f2f' : '#ffffff'} strokeWidth={isGap ? 2 : 1}
                strokeDasharray={isGap ? '5 4' : undefined} />
              <text x={x + TILE_W / 2} y={y + 34} textAnchor="middle" fontSize="15" fontWeight="600" fill={tColor}>
                {SHORT[province] || province}
              </text>
              <text x={x + TILE_W / 2} y={y + 60} textAnchor="middle" fontSize="13" fill={tColor}>
                {stats.contractors} contractor{stats.contractors === 1 ? '' : 's'}
              </text>
              <text x={x + TILE_W / 2} y={y + 80} textAnchor="middle" fontSize="13" fill={tColor}>
                {stats.verifiers} verifier{stats.verifiers === 1 ? '' : 's'}
              </text>
            </g>
          );
        })}
      </svg>
      <Box sx={{ display: 'flex', gap: 2, mt: 1, flexWrap: 'wrap', alignItems: 'center' }}>
        <Typography variant="caption" color="text.secondary">Coverage density:</Typography>
        {['#fbeaea', '#a5d6a7', '#4caf50', '#2e7d32', '#1b5e20'].map((c, i) => (
          <Box key={c} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Box sx={{ width: 14, height: 14, bgcolor: c, border: '1px solid #ccc', borderRadius: 0.5 }} />
            <Typography variant="caption" color="text.secondary">{['none', 'low', 'med', 'high', 'top'][i]}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
